// @flow

import React from 'react';
import Redirect from '../../components/Redirect';

export default () => <Redirect to="/statistics/visits/" />;
